import clsx from 'clsx';
import { HubertSlider } from 'components/HubertUI/HubertSlider';
import type { ComponentProps } from 'react';
import type { TMatrixSliderEvaluationWeighted } from 'types/evaluation.types';

interface Props extends ComponentProps<'div'> {
  evaluation: TMatrixSliderEvaluationWeighted;
  onEvaluationChange: (e: number[]) => void;
}

const MatrixEvaluationWeighted = ({ evaluation, onEvaluationChange, ...props }: Props) => {
  return (
    <div {...props} className={clsx('flex flex-col justify-between gap-4', 'py-4')}>
      <div className={clsx('flex flex-row justify-between gap-4', 'px-2 py-4', 'hubert-vertical-center')}>
        <div className="mx-2 px-2">{(evaluation.weight * 100).toFixed(2)} %</div>
        <div className="w-3/4 max-w-3/4">
          <HubertSlider
            value={[evaluation.weight]}
            min={0}
            max={1}
            step={0.01}
            onValueChange={(e) => {
              console.log('onValueChange e: ', e);
              // setConditionValue(e);
              // if (onUpdateItem) {
              //   onUpdateItem('condition-value', e);
              // }
              if (onEvaluationChange) {
                onEvaluationChange(e);
              }
            }}
            // onValueCommit={(e: number[]) => {
            //   console.log('onValueCommit e: ', e);
            //   if (onEvaluationChange) {
            //     onEvaluationChange(e);
            //   }
            // }}
          />
        </div>
      </div>
    </div>
  );
};

export default MatrixEvaluationWeighted;
